const style = {
  previewContainer: {
    backgroundColor: '#3D4A4D',
    color: 'white',
    flex: 1,
    display: 'flex',
  },
  centeredInfoText: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default style;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectPreview/ProjectPreview.styles.js